import { render, staticRenderFns } from "./singleSelect.vue?vue&type=template&id=1b16a98a&scoped=true"
import script from "./singleSelect.vue?vue&type=script&lang=js"
export * from "./singleSelect.vue?vue&type=script&lang=js"
import style0 from "./singleSelect.vue?vue&type=style&index=0&id=1b16a98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16a98a",
  null
  
)

export default component.exports